import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "bg-light mb-4 py-3 px-3 shadow-sm rounded"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h5", { class: "py-2 mb-3 text-primary border-bottom" }, "Deixe sua mensagem (opcional) ", -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_6 = {
    class: "custom-control-label",
    for: "concordo_termos_uso"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = {
    key: 0,
    class: "col-12"
};
const _hoisted_9 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "nao_sou_permissionario"
}, "Não sou permissionário de Serviços Públicos.", -1);
const _hoisted_11 = {
    key: 1,
    class: "col-12"
};
const _hoisted_12 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "estou_ciente_limite_ir"
}, "Estou ciente do limite de doação de 10% dos meus rendimentos brutos em 2019.", -1);
const _hoisted_14 = {
    key: 2,
    class: "col-12"
};
const _hoisted_15 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "nao_sou_beneficiario_programas_sociais"
}, "Não sou beneficiário de Programas Sociais (Ex.: Bolsa Família).", -1);
const _hoisted_17 = { class: "col-12 mb-3 mb-lg-0" };
const _hoisted_18 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "aceita_receber_emails_marketing"
}, "Aceito receber notícias, promoções e novidades da Campanha do Bem.", -1);
const _hoisted_20 = {
    key: 3,
    class: "col-12 mt-2"
};
const _hoisted_21 = { class: "page-actions" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-thumbs-up" }, null, -1);
const _hoisted_24 = {
    key: 0,
    class: "fa fa-spinner fa-spin fa-1x fa-fw"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_vue_recaptcha = _resolveComponent("vue-recaptcha");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!_ctx.campanha.is_politica)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _withDirectives(_createElementVNode("textarea", {
                    rows: "3",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.doacao.mensagem) = $event)),
                    maxlength: "255"
                }, null, 512), [
                    [_vModelText, _ctx.doacao.mensagem]
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                        id: "concordo_termos_uso",
                        name: "concordo_termos_uso",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.doacao.concordo_termos_uso) = $event)),
                        class: "custom-control-input",
                        type: "checkbox",
                        required: ""
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.doacao.concordo_termos_uso]
                    ]),
                    _createElementVNode("label", _hoisted_6, [
                        _createTextVNode("Concordo com os "),
                        _createElementVNode("a", {
                            target: "_blank",
                            href: _ctx.urlTermosUso,
                            style: { "margin-left": "5px" }
                        }, "termos de uso", 8, _hoisted_7),
                        _createTextVNode(".")
                    ])
                ])
            ]),
            (_ctx.campanha.is_politica)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                            id: "nao_sou_permissionario",
                            name: "nao_sou_permissionario",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.doacao.nao_sou_permissionario) = $event)),
                            class: "custom-control-input",
                            type: "checkbox",
                            required: ""
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.doacao.nao_sou_permissionario]
                        ]),
                        _hoisted_10
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.campanha.is_politica)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                            id: "estou_ciente_limite_ir",
                            name: "estou_ciente_limite_ir",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.doacao.estou_ciente_limite_ir) = $event)),
                            class: "custom-control-input",
                            type: "checkbox",
                            required: ""
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.doacao.estou_ciente_limite_ir]
                        ]),
                        _hoisted_13
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.campanha.is_politica)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                            id: "nao_sou_beneficiario_programas_sociais",
                            name: "nao_sou_beneficiario_programas_sociais",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.doacao.nao_sou_beneficiario_programas_sociais) = $event)),
                            class: "custom-control-input",
                            type: "checkbox",
                            required: ""
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.doacao.nao_sou_beneficiario_programas_sociais]
                        ]),
                        _hoisted_16
                    ])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                        id: "aceita_receber_emails_marketing",
                        name: "aceita_receber_emails_marketing",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.doacao.aceita_receber_emails_marketing) = $event)),
                        class: "custom-control-input",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.doacao.aceita_receber_emails_marketing]
                    ]),
                    _hoisted_19
                ])
            ]),
            (!_ctx.recaptchaDisabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _withDirectives(_createVNode(_component_vue_recaptcha, {
                        sitekey: _ctx.recaptchaSiteKey,
                        size: "normal",
                        hl: "pt-br",
                        "loading-timeout": _ctx.loadingTimeout,
                        onVerify: _ctx.recaptchaVerified,
                        onExpire: _ctx.recaptchaExpired,
                        ref: "vueRecaptcha"
                    }, null, 8, ["sitekey", "loading-timeout", "onVerify", "onExpire"]), [
                        [_vShow, _ctx.showRecaptcha]
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.runRecaptchaAndSave())),
                class: "mb-1 btn btn-lg text-4 btn-primary-2 btn-block",
                disabled: _ctx.isSalvando
            }, [
                _hoisted_23,
                _createTextVNode(" CONTRIBUIR "),
                (_ctx.isSalvando)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_22)
        ])
    ], 64));
}
